import { render, staticRenderFns } from "./DemoLanding.vue?vue&type=template&id=2e052760&scoped=true"
import script from "./DemoLanding.vue?vue&type=script&lang=js"
export * from "./DemoLanding.vue?vue&type=script&lang=js"
import style0 from "./Demo.scss?vue&type=style&index=0&id=2e052760&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e052760",
  null
  
)

export default component.exports